import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/**Models */
import { Device, Agreements } from '@models';

/*Services */
import { DevicesService } from '@services/http/devices.service';
import { StateService } from '@services/state.service';
import { TariffService } from '@services/tariff.services';
import { CachedDataService } from '@services/data/cached-data.service';
/*Plugins */
import { BsModalComponent } from 'ng2-bs3-modal';

declare var swal: any;


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'agreements-modal',
  templateUrl: './agreements-modal.component.html'
})

export class AgreementsModalComponent  implements OnDestroy {

  @ViewChild('agreementsModal') agreementsModal: BsModalComponent;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
agreementMinuteTimerShow = 1;
  currentDevice: Device;
  currentDeviceId: string;
  currentAgreements:Agreements;
  currentStep: number = 1;
  intervalTimer;
  isOpenModal = false;
  uploadedFiles = {
      passportScan: null,
      passportSecondScan: null,
      registrationScan: null,
      registrationSecondScan: null
  };
  trySubmit = false;
  btnText = {
      default: "Отправить",
      load: "Загрузка...",
      text: "Отправить"
  }


  constructor(
      private stateService: StateService,
      private tariffService: TariffService,
      private cachedDataService: CachedDataService
  ) {
    this.stateService.initAgreementsModalObservable
        .takeUntil(this.ngUnsubscribe)
        .subscribe((deviceId) => {
            //при добавлении девайса
            this.clearAgreementTimer();
            this.currentDeviceId = deviceId;
            this.initModalTImer();
        });
    this.stateService.showAgreementsModalObservable
        .takeUntil(this.ngUnsubscribe)
        .subscribe((deviceId) => {
            this.currentDeviceId = deviceId;
            this.open();
        });
    this.stateService.removeAgreementsObservable
        .takeUntil(this.ngUnsubscribe)
        .subscribe((deviceId) => {
            this.removeAgreements(deviceId)
        });
        
    this.stateService.currentDeviceObservable
        .takeUntil(this.ngUnsubscribe)
        .subscribe(device => {
          this.currentDevice = device;
          
          if(this.currentDevice.isTariffAgreementCompleted == false){
            this.currentDeviceId = device.id;
            this.initModalTImer();
          }
        });
  }
  initModalTImer(){
    let agreementTimer = this.cachedDataService.getCurrentAgreementTimer();
    if(this.isOpenModal){
        //Если уже открыт - значит сбрасываем таймер и пропускаем открытие 
        this.setAgreementTimer();
        return false;
    }
    if(!agreementTimer){
        this.open();
        this.setAgreementTimer()
        
    }else{
        this.getDiffMinutes(parseInt(agreementTimer))
        // добавить проверку, прошло ли 6 минут с последнего показа
    }
    console.log("initagreements")
  }
  getDiffMinutes(agreementTimer: number){
    let minutesDifference = (new Date().getTime()  - new Date(agreementTimer).getTime())/1000/60;
    console.log(minutesDifference)
    if(minutesDifference>=this.agreementMinuteTimerShow){
        this.open();
        this.setAgreementTimer();
    }
  }
  clearAgreementTimer(){
    clearInterval(this.intervalTimer);
    this.cachedDataService.clearCurrentAgreementTimer()
  }
  setAgreementTimer(){
    if(this.intervalTimer){
        clearInterval(this.intervalTimer);
    }
    this.intervalTimer = setInterval(()=>{
        this.initModalTImer();
    },1000*60*180)
    this.cachedDataService.setCurrentAgreementTimer((new Date().getTime()).toString())
  }

  removeAgreements(deviceId: string){
    //добавить удаление конкретного договора для конкретного устройства 
    this.clearAgreementTimer();
  }

    open() {
        this.currentStep = 1;
        this.isOpenModal = true;
        this.getAgreements();
        this.agreementsModal.open();
    }
    getAgreements(){
        this.tariffService.getAgreements(this.currentDeviceId)
            .subscribe(response => {
                let startString = "ДОГОВОР</h3>";
                let endString ="</body>\r\n</html>";
                let agreementText = response.text.split(startString)[1];
                agreementText = agreementText.split(endString)[0];
            
               
                this.currentAgreements = {
                    id:response.id,
                    code:response.code,
                    text:agreementText,
                    status: response.status
                }
            },
            error => {
                swal({
                    type: 'error',
                    title: 'Ошибка',
                    text: 'Ошибка при загрузке договора, попробуйте позже.',
                    showConfirmButton: false,
                    timer: 3000,
                  });
                console.log(error)
            })
    }
    acceptAgreements(){
        this.currentStep++;
    }
    cancelAgreements(){
        swal({
            text: 'Необходимо принять договор и отправить данные фото со сроком не более 3 дней. Вы уверены что хотите прервать загрузку? ',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#23518d',
            confirmButtonText: 'Прервать и продолжить позже',
            cancelButtonText: 'Продолжить'
          }).then((result) => {
            if (result.value) {
                this.isOpenModal = false;
                this.agreementsModal.close();
            }
          });

    }
    uploadFileEvent(file, type: string){
        console.log(file)
        this.uploadedFiles[type] = file;
        console.log(this.uploadedFiles)
    }
    submit(){
        this.trySubmit = true;
        if( !this.uploadedFiles.passportScan || 
            !this.uploadedFiles.passportSecondScan || 
            !this.uploadedFiles.registrationScan || 
            !this.uploadedFiles.registrationSecondScan){
            return false;
        }
        this.btnText.text = this.btnText.load;

        this.tariffService.sendAgreements(
                this.currentAgreements.id,
                this.uploadedFiles.passportScan,
                this.uploadedFiles.passportSecondScan,
                this.uploadedFiles.registrationScan,
                this.uploadedFiles.registrationSecondScan)
            .subscribe(response => {
                this.btnText.text = this.btnText.default;
                swal({
                        type: 'success',
                        text: 'Документы загружены',
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    this.clearAgreementTimer();
                    this.stateService.agreementsCompletedSubject.next(this.currentDeviceId);
                   
                    this.close();
            },
            error => {
                this.btnText.text = this.btnText.default;
                swal({
                    type: 'error',
                    title: 'Ошибка',
                    text: 'Команда не выполнена, попробуйте позже.',
                    showConfirmButton: false,
                    timer: 3000,
                  });
            })
    }
    close() {
        this.isOpenModal = false;
        this.agreementsModal.close();
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

}



// WEBPACK FOOTER //
// ./src/app/view/modal/agreements-modal/agreements-modal.component.ts